import { DropDownTranslator } from "./DropDownTranslator";

export function ScanNavbar() {
  return (
    <div className="flex justify-between gap-3 w-full border-b p-4">
      <div className="flex items-center gap-3">
        <div className="flex size-12 shrink-0 items-center justify-center rounded-lg text-primary-foreground">
          <img src="/resources/logo.png" alt="MTrack logo" className="h-full w-full object-contain" />
        </div>

        <div className="flex flex-col">
          <span className="text-sm font-semibold text-foreground">MTrack</span>
          <span className="text-[10px] text-muted-foreground">Medical Equipment Management</span>
        </div>
      </div>

      <DropDownTranslator />
    </div>
  )
}